import http from './axios'

// 查询列表
const queryPage = () => {
    return http.get('/manager/dailyReport/todayReport')
}

export default {
    queryPage,
}